<template>
  <Modal v-model="onlineBalanceRechargeConfigModal" :title="$t('key1001839')" width="700" :transfer="false"
    :mask-closable="false" @on-visible-change="onlineBalanceRechargeConfigChange">
    <div class="flex flex-wrap mb20">
      <div class="width_80">{{ $t('key1002495') }}</div>
      <CheckboxGroup class="flex flex-wrap flex_1" v-model="channelValueList">
        <Checkbox class="mr30 mb15" v-for="item in channelList" :label="item.value">{{ item.name }}</Checkbox>
      </CheckboxGroup>
    </div>
    <template #footer>
      <Button @click="onlineBalanceRechargeConfigModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="onlineBalanceRechargeConfigBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import {commonLocalStorage, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'onlineBalanceRechargeConfigModal',
  mixins: [Mixin],
  props: {
    enumData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      onlineBalanceRechargeConfigModal: false,
      channelValueList: [],
      channelList: [],
      configParamKey: null,
      enumKey: 'PaymentMethodEnum',
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    initOnlineBalanceRechargeData(paramKey, paramValue) {
      const configItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      let onlineBalanceRechargeSaas = configItems?.onlineBalanceRechargeSaas || [];
      this.channelList = onlineBalanceRechargeSaas.map((val) => {
        return {
          value: val,
          name: this.enumData[`${this.enumKey}_${val}`] || '',
        }
      });
      this.channelValueList = paramValue || [];
      this.configParamKey = paramKey;
      this.onlineBalanceRechargeConfigModal = true;
    },
    // 确定
    onlineBalanceRechargeConfigBtn() {
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: JSON.stringify(this.channelValueList),
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000708'));
        this.onlineBalanceRechargeConfigModal = false;
        this.$emit('updateConfigData', true);
      });
    },
    // 监听弹窗
    onlineBalanceRechargeConfigChange(value) {
      if (!value) {
        this.channelValueList = [];
        this.configParamKey = null;
      }
    }
  }
};
</script>

<style lang="less">

</style>
